import React, { Component } from "react";
import IntelligentHeader from "../IntelligentAllMajorModal/components/IntelligentHeader";
import SchoolDetail from "../../../../SchoolDetail";
import "./style.css";
import "../../../../../index.css";
class IntelligentSchoolDetail extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    const { visible, handleVisibleSchoolDetail, aHashId } = this.props;
    return (
      <div
        style={{ zIndex: 999 }}
        className={
          visible === true
            ? "intelligentAllMajorModal_box"
            : "intelligentAllMajorModal_box display_none"
        }
      >
        <IntelligentHeader
          handleVisible={handleVisibleSchoolDetail}
        ></IntelligentHeader>
        <SchoolDetail
          from="/intelligentbigdata/home"
          aHashId={aHashId}
          visible={visible}
        ></SchoolDetail>
      </div>
    );
  }
}

export default IntelligentSchoolDetail;



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentSchoolDetail/index.js